interface Props {
  dataTestId?: string;
  className?: string;
}
const InPageSpinner = ({
  dataTestId,
  className
}: Props) => {
  return <div className={`w-5 h-5 border-t-2 border-b-2 border-primary-100 rounded-full animate-spin mx-auto ${className}`} data-testid={dataTestId} data-sentry-component="InPageSpinner" data-sentry-source-file="InPageSpinner.tsx" />;
};
export default InPageSpinner;